import React from 'react';

import Helmet from 'react-helmet';
import { IntlShape, useIntl } from 'react-intl';
import { useLocation } from 'react-router';

import { removeLocaleFromUrl } from 'helpers/locales';

const urlsWithCustomTitle = [
  'browse',
  'explore',
  'my-femtasy',
  'onboarding',
  'pricing',
  'sign-in',
  'sign-up',
  'studentverification',
  'subscription',
];

const urlsWithCustomDescription = [
  'browse',
  'explore',
  'my-femtasy',
  'onboarding',
  'pricing',
  'sign-in',
  'sign-up',
  'studentverification',
  'subscription',
];

const getTranslation = (pathname: String, urls: Array<String>) => {
  const pathWithoutLocale = removeLocaleFromUrl(pathname);
  const path = pathWithoutLocale.replace('/', '');

  const customTranlation = urls.find((url) => {
    return path.startsWith(url) ? url : undefined;
  });

  return customTranlation;
};

const getTitleText = (intl: IntlShape, pathname: String) => {
  const customTitle = getTranslation(pathname, urlsWithCustomTitle);
  const translation = customTitle ? customTitle : 'defaultTitle';

  if (pathname.match(/\/ext\//)) {
    return intl.formatMessage({
      id: 'components.SiteMetaInformation.title.ext',
    });
  }

  return intl.formatMessage({
    id: `components.SiteMetaInformation.title.${translation}`,
  });
};

const getDescriptionText = (intl: IntlShape, pathname: String) => {
  const customDescription = getTranslation(pathname, urlsWithCustomDescription);

  const translation = customDescription
    ? customDescription
    : 'defaultDescription';

  if (pathname.match(/\/ext\//)) {
    return intl.formatMessage({
      id: 'components.SiteMetaInformation.description.ext',
    });
  }

  return intl.formatMessage({
    id: `components.SiteMetaInformation.description.${translation}`,
  });
};

const SiteMetaInformation = () => {
  const { pathname } = useLocation();
  const intl = useIntl();

  return (
    <Helmet>
      <title>{getTitleText(intl, pathname)}</title>
      <meta
        name="description"
        content={getDescriptionText(intl, pathname)}
        data-react-helmet="true"
      />
    </Helmet>
  );
};

export default SiteMetaInformation;
